import { render, staticRenderFns } from "./BankTransferPurchase.vue?vue&type=template&id=dca898c0"
import script from "./BankTransferPurchase.vue?vue&type=script&lang=ts"
export * from "./BankTransferPurchase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports